import { Eye } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconEye12Line = createIcon(Eye, 12, "Line");
export const IconEye16Line = createIcon(Eye, 16, "Line");
export const IconEye20Line = createIcon(Eye, 20, "Line");
export const IconEye24Line = createIcon(Eye, 24, "Line");
export const IconEye32Line = createIcon(Eye, 32, "Line");
export const IconEye48Line = createIcon(Eye, 48, "Line");
export const IconEye64Line = createIcon(Eye, 64, "Line");
